import { render, staticRenderFns } from "./FrontendLogo.vue?vue&type=template&id=7cae20ba"
import script from "./FrontendLogo.vue?vue&type=script&lang=js"
export * from "./FrontendLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports